import { render } from "./PortalSidebarNavGroup.vue?vue&type=template&id=e64a22a2"
import script from "./PortalSidebarNavGroup.vue?vue&type=script&lang=js"
export * from "./PortalSidebarNavGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__